import { useMount, useRequest } from 'ahooks';
import { isNumber } from 'lodash';
import { EditableTableFormInstance } from 'react-pro-components/typings/components/editable-table-2/types';

import { getWorkstationActivityType } from '../api';
import { WorkstationActivityType } from '../type';

export const useInitForm = (form: EditableTableFormInstance<WorkstationActivityType>, setDataSource: (dataSource: any[]) => void) => {
  const { runAsync, loading } = useRequest(getWorkstationActivityType, { manual: true });
  const refresh = async () => {
    const { list = [] } = await runAsync({});
    const noSeqs = list.filter((item) => isNumber(item.sequence) && item.sequence === 0).map((item) => ({ ...item, sequence: undefined }));
    const seqs = list.filter((item) => isNumber(item.sequence) && item.sequence !== 0);
    seqs.sort((a, b) => a.sequence as number - (b.sequence as number));
    const dataSource = seqs.concat(noSeqs);
    setDataSource(dataSource);
    form.setDataSource(dataSource);
  };
  useMount(refresh);
  return {
    loading,
    refresh
  };
};
